import { render, staticRenderFns } from "./Minimal.vue?vue&type=template&id=11dadc34&scoped=true&"
import script from "./Minimal.vue?vue&type=script&lang=js&"
export * from "./Minimal.vue?vue&type=script&lang=js&"
import style0 from "./Minimal.vue?vue&type=style&index=0&id=11dadc34&lang=scss&scoped=true&"
import style1 from "./Minimal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dadc34",
  null
  
)

export default component.exports